export const removeCurrencyMask = (value: string): number => {
  if (value.includes(',') && value.includes('.')) {
    return Number(
      parseFloat(
        String(value).trim().replace(/\./g, '').replace(/,/, '.')
      ).toFixed(2)
    )
  }

  if (value.includes(',')) {
    return Number(value.replace(',', '.'))
  }

  return Number(value)
}
